import { APIFetchError } from "@cur8/api-client";
import { BarcodeAssignmentMode } from "hooks/mutations/useBarcodeAssignmentMutation";

const INFINITIVE: Record<BarcodeAssignmentMode, string> = {
  assign: "assign",
  reassign: "re-assign",
};

export function barcodeAssignmentErrorMessage(
  error: unknown,
  mode: BarcodeAssignmentMode,
  barcodeId: string
): string {
  if (error instanceof APIFetchError && error.response.status === 409) {
    return `Barcode ${barcodeId} is already assigned to another member or visit.`;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return `Failed to ${INFINITIVE[mode]} barcode ${barcodeId}`;
}
